module.exports = __webpack_public_path__ + "img/DNT.4f4cc5cc.svg";